import { HugeiconsIcon } from "@hugeicons/react";
import { Notification01Icon } from "@hugeicons-pro/core-solid-rounded";

export const UnitActivityPill = ({
  count,
  onClick
}: {
  count: number;
  onClick: (event: React.MouseEvent) => void;
}) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={`${count} new activity`}
    className="flex h-6 items-center gap-1 rounded-full bg-primary-20 pl-2 pr-2.5 text-sm font-bold text-primary-500 shadow-xs"
  >
    <HugeiconsIcon size={14} icon={Notification01Icon} />
    {count}
  </button>
);
